export default __webpack_public_path__ + "ui/assets/img/arrow-forward-20.svg";